import { useEffect } from "react"
import { datadogRum } from "@datadog/browser-rum"
import packageJson from "../../package.json"

export function useDatadogRum() {
  useEffect(() => {
    if (!(process.env.REACT_APP_DATADOG_RUM === "true")) {
      return
    }

    datadogRum.init({
      applicationId: "d8c8659d-1f1b-4ac4-8d71-a87cc63f17a8",
      clientToken: "pubc317e3ac8b87ea970d67e962b2d398c1",
      site: "datadoghq.com",
      service: "h3-dashboard-ui",
      env: process.env.REACT_APP_DATADOG_RUM_ENV || "development",
      version: packageJson.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    })
  }, [])
}
